import axios from "axios";
import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import swal from "sweetalert";
import LoaderHome from "../../../../Loader/LoaderHome"


import { GetPatientSDC, GetPatientByNIKSatuSehat, GetPatientIndexEncounter, GetPatientIndexEncounterById, GetPatientConditionByEncounterId, GetPatientObservationByEncounterId, GetPatientProcedureByEncounterId, PostAppointmentSSP, PostBloodTypeSSP, GetPhysicalCheckPatientSDC, GetAppointmentSSPSDC, PostRhesusSSP, PostPregnancyStatusSSP, PostEncounterSSP, GetDoctorSDC, GetLocationSatuSehat, GetDebrisIndexSDC, PostDebrisIndexSSP, PostKalkulusIndexSSP, GetKalkulusIndexSDC, PostScoreKalkulusIndexSSP, PostScoreDebrisIndexSSP, PostPatientSSP, PutBloodTypeSSP, PutRhesusSSP, PutPregnancyStatusSSP, PutDebrisIndexSSP, PutKalkulusIndexSSP, PutSkorKalkulusIndexSSP, PutSkorDebrisIndexSSP, PutSistoleSSP, PostSistoleSSP, PutDistoleSSP, PostDistoleSSP, PutSuhuSSP, PostSuhuSSP, PostTreatmentSSP, PutTreatmentSSP } from "./Function/PostDataEncounter";
import Swal from "sweetalert2";


export default function SendSSP(props) {
    const [patientData, setPatientData] = useState(null);
    const [debrisIndexData, setDebrisIndexData] = useState(null);
    const [kalkulusIndexData, setKalkulusIndexData] = useState(null);
    const [appointmentData, setGetDataAppointmentSSPSDC] = useState(null);
    const [doctorData, setDoctorData] = useState(null);
    const [getLocationSSPData, setLocationSSPData] = useState(null);
    const [getPhysicalCheckPatientData, setPhysicalCheckPatientData] = useState(null);
    const [getDataPatientByNikSatuSehat, setGetDataPatientByNikSatuSehat] = useState(null);
    const [getPatientIndexEncounterSatuSehat, setGetPatientIndexEncounterSatuSehat] = useState(null);
    const [getPatientIndexEncounterByIdSatuSehat, setGetPatientIndexEncounterByIdSatuSehat] = useState(null);
    const [getPatientConditionByEncounterSatuSehat, setGetPatientConditionByEncounterSatuSehat] = useState(null);
    const [getPatientObservationByEncounterSatuSehat, setGetPatientObservationByEncounterSatuSehat] = useState(null);
    const [getPatientProcedureByEncounterSatuSehat, setGetPatientProcedureByEncounterSatuSehat] = useState(null);
    const [isDuplicate, setIsDuplicate] = useState(false);
    const [buttonLabel, setButtonLabel] = useState("Kirim Satu Sehat");
    const [buttonColour, setButtonColour] = useState("");
    const [patientSSPDuplicate, setPatientSSPDuplicate] = useState(null);
    const [isPatientDataValid, setIsPatientDataValid] = useState(null);
    const [isLocationDataValid, setIsLocationDataValid] = useState(null);


    const [showEncounterSSPButton, setShowEncounterSSPButton] = useState(false);
    const [showAppointmentSSPButton, setShowAppointmentSSPButton] = useState(false);
    const [showBloodButton, setShowBloodButton] = useState(false);
    const [showRhesusButton, setShowRhesusButton] = useState(false);
    const [showPregnancyStatusButton, setShowPregnancyStatusButton] = useState(false);
    const [showDebrisIndexButton, setShowDebrisIndexButton] = useState(false);
    const [showKalkulusIndexButton, setShowKalkulusIndexButton] = useState(false);
    const [showScoreKalkulusIndexButton, setShowScoreKalkulusIndexButton] = useState(false);
    const [showScoreDebrisIndexButton, setShowScoreDebrisIndexButton] = useState(false);
    const [showSistoleSSPButton, setShowSistoleSSPButton] = useState(false);
    const [showDistoleSSPButton, setShowDistoleSSPButton] = useState(false);
    const [showSuhuSSPButton, setShowSuhuSSPButton] = useState(false);
    const [showProcedureSSPButton, setShowProcedureSSPButton] = useState(false);


    const [loading, setLoading] = useState(false);
    // StartPatient
    const GetPatientSDCFunc = async () => {
        try {
            const patientId = props?.id_patient
            const response = await GetPatientSDC(patientId)
            setPatientData(response);
        } catch (error) {
            console.log(error)
            swal({
                title: 'Failed',
                text: "Error",
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    }
    useEffect(() => {
        if (!props?.id_patient) return;
        GetPatientSDCFunc();
    }, [props?.id_patient]);

    const GetDebrisSDCFunc = async () => {
        try {
            const patientId = props?.id_patient
            const appointmentId = props?.id_appointment
            const response = await GetDebrisIndexSDC(patientId, appointmentId)
            setDebrisIndexData(response)
            // setPatientData(response);
        } catch (error) {
            console.log(error)
            const apiMessage = error?.response?.data?.message;

        }
    }
    useEffect(() => {
        if (!props?.id_patient, !props?.id_appointment) return;
        GetDebrisSDCFunc();
    }, [props?.id_patient, props?.id_appointment]);

    const GetkalkulusSDCFunc = async () => {
        try {
            const patientId = props?.id_patient
            const appointmentId = props?.id_appointment
            const response = await GetKalkulusIndexSDC(patientId, appointmentId)
            setKalkulusIndexData(response)
            // setPatientData(response);
        } catch (error) {
            console.log(error)
            const apiMessage = error?.response?.data?.message;

            swal({
                title: 'Failed',
                text: "Error",
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    }
    useEffect(() => {
        if (!props?.id_patient, !props?.id_appointment) return;
        GetkalkulusSDCFunc();
    }, [props?.id_patient, props?.id_appointment]);

    const GetDoctorSDCFunc = async () => {
        try {
            const doctorId = props?.id_doctor
            const response = await GetDoctorSDC(doctorId)
            setDoctorData(response);
        } catch (error) {
            console.log(error)
            swal({
                title: 'Failed',
                text: "Error",
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    }
    useEffect(() => {
        if (!props?.id_doctor) return;
        GetDoctorSDCFunc();
    }, [props?.id_doctor]);


    const GetLocationSSPFunc = async () => {
        try {
            const roomId = props?.id_room
            const response = await GetLocationSatuSehat(roomId)
            setLocationSSPData(response.data);
            setIsLocationDataValid(true)
        } catch (error) {
            console.log(error)
            swal({
                title: 'Failed',
                text: "Error",
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    }
    useEffect(() => {
        if (!props?.id_room) return;
        GetLocationSSPFunc();
    }, [props?.id_room, props?.id_room]);

    // StartPatient
    const GetPhysicalCheckPatientSDCFunc = async () => {
        try {
            const patientId = props?.id_patient
            const response = await GetPhysicalCheckPatientSDC(patientId)
            setPhysicalCheckPatientData(response);
        } catch (error) {
            console.log(error)
            swal({
                title: 'Failed',
                text: "Error",
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    }
    useEffect(() => {
        if (!props?.id_patient) return;
        GetPhysicalCheckPatientSDCFunc();
    }, [props?.id_patient]);
    // EndPatient

    // StartPatient
    const GetAppointmentSSPSDCFunc = async () => {
        try {
            const patientId = props?.id_patient;
            const response = await GetAppointmentSSPSDC(patientId);
            setGetDataAppointmentSSPSDC(response)

        } catch (error) {
            console.log(error)

            // Kalau bukan kondisi di atas → tampilkan error biasa
            // swal({
            //     title: 'Failed',
            //     text: "Error",
            //     icon: 'error',
            //     timer: 3000,
            //     buttons: false
            // });

            console.error("GetAppointmentSSPSDCFunc Error:", error);
        }
    };

    useEffect(() => {
        if (!props?.id_patient) return;
        GetAppointmentSSPSDCFunc();
    }, [props?.id_patient]);
    // EndPatient


    // StartPatientByNikSatuSehat
    useEffect(() => {
        if (!patientData?.nic_number) return;

        const GetPatientByNIKSatuSehatFunc = async () => {
            try {
                const response = await GetPatientByNIKSatuSehat(patientData.nic_number);
                setGetDataPatientByNikSatuSehat(response.data.entry[0])

                setIsPatientDataValid(true);
            } catch (error) {
                const code = error?.response?.data?.error?.issue?.[0]?.code;
                const detailsText = error?.response?.data?.error?.issue?.[0]?.details?.text;
                const diagnostics = error?.response?.data?.error?.issue?.[0]?.diagnostics;

                // Jika error query / identifier tidak valid
                if (code === "value" || detailsText === "Invalid query") {
                    swal({
                        title: "Gagal Mengirim Data",
                        text: diagnostics || "Terjadi kesalahan pada format data yang dikirim. Periksa kembali data pasien.",
                        icon: "error",
                        timer: 3000,
                        buttons: false,
                    });
                    return;
                }

                swal({
                    title: "Terjadi Kesalahan",
                    text: detailsText || "Tidak dapat memproses permintaan. Silakan coba lagi.",
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
            }

        };

        GetPatientByNIKSatuSehatFunc();
    }, [patientData]);
    // EndPatientByNikSatuSehat

    // StartEncounterSatuSehat
    useEffect(() => {
        if (!getDataPatientByNikSatuSehat?.resource?.id) return;

        const GetPatientEncounterSatuSehatFunc = async () => {
            try {
                const response = await GetPatientIndexEncounter(getDataPatientByNikSatuSehat?.resource?.id);
                setGetPatientIndexEncounterSatuSehat(response.data.entry[0])
            } catch (error) {
                console.log(error)
                swal({
                    title: 'Failed',
                    text: "Error GetPatientEncounterSatuSehatFunc",
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            }
        };

        GetPatientEncounterSatuSehatFunc();
    }, [getDataPatientByNikSatuSehat?.resource?.id]);
    // EndEncounterSatuSehat

    // StartEncounterByIdSatuSehat
    useEffect(() => {
        if (!getPatientIndexEncounterSatuSehat?.resource?.id) return;

        const GetPatientEncounterByIdSatuSehatFunc = async () => {
            try {
                const response = await GetPatientIndexEncounterById(getPatientIndexEncounterSatuSehat?.resource?.id);
                setGetPatientIndexEncounterByIdSatuSehat(response.data)
            } catch (error) {
                console.log(error)
                swal({
                    title: 'Failed',
                    text: "Error GetPatientEncounterByIdSatuSehatFunc",
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            }
        };

        GetPatientEncounterByIdSatuSehatFunc();
    }, [getPatientIndexEncounterSatuSehat?.resource?.id]);
    // EndEncounterByIdSatuSehat

    // StartConditionByIdEncounterSatuSehat
    useEffect(() => {
        if (!getPatientIndexEncounterSatuSehat?.resource?.id) return;

        const GetPatientConditionByEncounterIdSatuSehatFunc = async () => {
            try {
                const response = await GetPatientConditionByEncounterId(getPatientIndexEncounterSatuSehat?.resource?.id);
                setGetPatientConditionByEncounterSatuSehat(response.data)
            } catch (error) {
                console.log(error)
                swal({
                    title: 'Failed',
                    text: "Error GetPatientConditionByEncounterIdSatuSehatFunc",
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            }
        };

        GetPatientConditionByEncounterIdSatuSehatFunc();
    }, [getPatientIndexEncounterSatuSehat?.resource?.id]);
    // EndConditionByIdEncounterSatuSehat

    // StartObservationByIdEncounterSatuSehat
    useEffect(() => {
        if (!getPatientIndexEncounterSatuSehat?.resource?.id) return;

        const GetPatientObservationByEncounterIdSatuSehatFunc = async () => {
            try {
                const response = await GetPatientObservationByEncounterId(getPatientIndexEncounterSatuSehat?.resource?.id);
                setGetPatientObservationByEncounterSatuSehat(response.data)
            } catch (error) {
                console.log(error)
                swal({
                    title: 'Failed',
                    text: "Error GetPatientObservationByEncounterIdSatuSehatFunc",
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            }
        };

        GetPatientObservationByEncounterIdSatuSehatFunc();
    }, [getPatientIndexEncounterSatuSehat?.resource?.id]);
    // EndObservationByIdEncounterSatuSehat

    // StartProcedureByIdEncounterSatuSehat
    useEffect(() => {
        if (!getPatientIndexEncounterSatuSehat?.resource?.id) return;

        const GetPatientProcedureByEncounterIdSatuSehatFunc = async () => {
            try {
                const response = await GetPatientProcedureByEncounterId(getPatientIndexEncounterSatuSehat?.resource?.id);
                setGetPatientProcedureByEncounterSatuSehat(response.data)
            } catch (error) {
                console.log(error)
                swal({
                    title: 'Failed',
                    text: "Error GetPatientProcedureByEncounterIdSatuSehatFunc",
                    icon: 'error',
                    timer: 3000,
                    buttons: false
                });
            }
        };

        GetPatientProcedureByEncounterIdSatuSehatFunc();
    }, [getPatientIndexEncounterSatuSehat?.resource?.id]);
    // EndProcedureByIdEncounterSatuSehat




    const UpdateDataBloodTypeSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutBloodTypeSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );
        } catch (error) {
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const UpdateDataRhesusSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutRhesusSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );
        } catch (error) {
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const UpdateDataPregnancyStatusSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutPregnancyStatusSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );
        } catch (error) {
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const UpdateDataDebrisIndexSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutDebrisIndexSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );
        } catch (error) {
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const UpdateDataKalkulusIndexSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutKalkulusIndexSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );
        } catch (error) {
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const UpdateDataSkorKalkulusIndexSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutSkorKalkulusIndexSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );
        } catch (error) {
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const UpdateDataSkorDebrisIndexSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutSkorDebrisIndexSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );
        } catch (error) {
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const UpdateDataSistoleSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            console.log(id_appointment)
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutSistoleSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );

            console.log("tes")
        } catch (error) {
            console.log(error, "error")
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const UpdateDataDistoleSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutDistoleSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );
        } catch (error) {
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const UpdateDataSuhuSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutSuhuSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );
        } catch (error) {
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const UpdateDataTreatmentSSPFunc = async () => {
        try {
            const id_appointment = appointmentData?.id_appointment;
            const id_patient = getDataPatientByNikSatuSehat?.resource?.id
            const id_appointment_ssp = appointmentData?.id_appointment_ssp
            await PutTreatmentSSP(
                id_appointment,
                id_patient,
                id_appointment_ssp
            );
        } catch (error) {
            swal({
                title: "Gagal",
                text: error,
                icon: "error",
                timer: 3000,
                buttons: false,
            });
        }
    };

    const PostPregnancyStatusSSPFunc = async () => {
        setLoading(true)
        try {
            setButtonLabel("Kirim Pregnancy Status SSP");

            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const pregnancyStatus = getPhysicalCheckPatientData?.pregnancy_status;
            const pregnancyStatusMap = {
                "Pregnancy": { code: "77386006", display: "Pregnancy" },
                "Not pregnant": { code: "60001007", display: "Not pregnant" },
            };

            const doctorName = props?.doctor_name
            const doctorIHSNumber = props?.doctor_id_ssp;
            const pregnancyStatusArray = pregnancyStatus
                ? [
                    {
                        code: pregnancyStatusMap[pregnancyStatus]?.code || "",
                        display: pregnancyStatusMap[pregnancyStatus]?.display || pregnancyStatus
                    }
                ]
                : [];
            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;

            await PostPregnancyStatusSSP(
                patientIdSSP,
                appointmentIdSSP,
                pregnancyStatusArray,
                createdAt,
                doctorName,
                doctorIHSNumber
            );

            UpdateDataPregnancyStatusSSPFunc()

            swal({
                title: "Success",
                text: "Status kehamilan satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });

            setShowPregnancyStatusButton(false)
            setShowDebrisIndexButton(true)
            setLoading(false)

        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code

            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data status kehamilan pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim!",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataPregnancyStatusSSPFunc()
                        setShowPregnancyStatusButton(false)
                        setShowDebrisIndexButton(true)

                        swal({
                            title: "Data Status Kehamilan",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message,
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                console.error("Error PostPregnancyStatusSSPFunc:", error);
                setLoading(false)
            }
        }
    };


    const PostRhesusSSPFunc = async () => {
        setLoading(true)
        try {
            setButtonLabel("Kirim Rhesus SSP");

            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const rhesus = getPhysicalCheckPatientData?.rhesus;
            const rhesusMap = {
                "Positive": { code: "LA6576-8", display: "Positive" },
                "Negative": { code: "LA6577-6", display: "Negative" },
            };
            const doctorIHSNumber = props?.doctor_id_ssp;
            const doctorName = props?.doctor_name

            const rhesusArray = rhesus
                ? [
                    {
                        code: rhesusMap[rhesus]?.code || "",
                        display: rhesusMap[rhesus]?.display || rhesus
                    }
                ]
                : [];
            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;

            await PostRhesusSSP(
                patientIdSSP,
                appointmentIdSSP,
                patientFirstname,
                patientLastname,
                rhesusArray,
                createdAt,
                doctorName,
                doctorIHSNumber
            );


            swal({
                title: "Data Status Rhesus",
                text: "Berhasil terkirim...",
                icon: "success",
                timer: 3000,
                buttons: false,
            });

            UpdateDataRhesusSSPFunc()
            swal({
                title: "Success",
                text: "Rhesus satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });

            setShowRhesusButton(false)
            setShowPregnancyStatusButton(true)
            setLoading(false)

        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code

            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data rhesus pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim!",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataRhesusSSPFunc()
                        setShowRhesusButton(false)
                        setShowPregnancyStatusButton(true)
                        swal({
                            title: "Data Rhesus",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message,
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
        }
    };


    const PostSistoleSSPFunc = async () => {
        setLoading(true)
        try {
            setButtonLabel("Kirim Sistole SSP");

            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const doctorFirstname = "Dokter Gigi"
            const doctorLastname = "Budiman";
            const blood_pressure = parseInt(getPhysicalCheckPatientData?.blood_pressure.split("/")[0]);

            if (!blood_pressure || isNaN(blood_pressure)) {
                swal({
                    title: 'Data sistole gagal dikirim',
                    text: 'Lengkapi data physical check pasien',
                    icon: 'warning',
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }

            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;
            const doctorName = props?.doctor_name
            const doctorIHSNumber = props?.doctor_id_ssp;

            await PostSistoleSSP(
                patientIdSSP,
                appointmentIdSSP,
                patientFirstname,
                patientLastname,
                doctorFirstname,
                doctorLastname,
                blood_pressure,
                createdAt,
                doctorIHSNumber,
                doctorName

            );


            swal({
                title: "Success",
                text: "Sistole satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });


            UpdateDataSistoleSSPFunc()
            setShowSistoleSSPButton(false)
            setShowDistoleSSPButton(true)
            setLoading(false)

        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code

            if (message === "duplicate") {
                // setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data sistole pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataSistoleSSPFunc()
                        setShowSistoleSSPButton(false)
                        setShowDistoleSSPButton(true)
                        swal({
                            title: "Data Sistole",
                            text: "Berhasil terkirim ke satu sehat...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message,
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
        }
    };

    const PostDistoleSSPFunc = async () => {
        setLoading(true)
        try {
            setButtonLabel("Kirim Distole SSP");

            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const doctorFirstname = "Dokter Gigi"
            const doctorLastname = "Budiman";
            const blood_pressure = parseInt(getPhysicalCheckPatientData?.blood_pressure.split("/")[1]);

            if (!blood_pressure || isNaN(blood_pressure)) {
                swal({
                    title: 'Data distole gagal dikirim',
                    text: 'Lengkapi data physical check pasien',
                    icon: 'warning',
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }

            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;

            const doctorName = props?.doctor_name
            const doctorIHSNumber = props?.doctor_id_ssp;

            await PostDistoleSSP(
                patientIdSSP,
                appointmentIdSSP,
                patientFirstname,
                patientLastname,
                doctorFirstname,
                doctorLastname,
                blood_pressure,
                createdAt,
                doctorIHSNumber,
                doctorName,
            );

            UpdateDataDistoleSSPFunc()
            swal({
                title: "Success",
                text: "Distole satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });


            setShowDistoleSSPButton(false)
            setShowSuhuSSPButton(true)
            setLoading(false)

        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code

            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data distole pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataDistoleSSPFunc()
                        setShowDistoleSSPButton(false)
                        setShowSuhuSSPButton(true)

                        swal({
                            title: "Data Distole",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message,
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
        }
    };

    const PostSuhuSSPFunc = async () => {
        setLoading(true)

        try {
            setButtonLabel("Kirim Suhu Badan SSP");

            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const doctorFirstname = "Dokter Gigi"
            const doctorLastname = "Budiman";
            const body_temperature = parseInt(getPhysicalCheckPatientData?.body_temperature);

            if (!body_temperature) {
                swal({
                    title: 'Data suhu badan gagal dikirim',
                    text: 'Lengkapi data physical check pasien',
                    icon: 'warning',
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;

            const doctorName = props?.doctor_name
            const doctorIHSNumber = props?.doctor_id_ssp;

            await PostSuhuSSP(
                patientIdSSP,
                appointmentIdSSP,
                patientFirstname,
                patientLastname,
                doctorFirstname,
                doctorLastname,
                body_temperature,
                createdAt,
                doctorIHSNumber,
                doctorName,
            );

            UpdateDataSuhuSSPFunc()
            swal({
                title: "Success",
                text: "Suhu satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });


            setShowSuhuSSPButton(false)
            setShowProcedureSSPButton(true)
            setLoading(false)

        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code

            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data suhu pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataSuhuSSPFunc()
                        setShowSuhuSSPButton(false)
                        setShowProcedureSSPButton(true)

                        swal({
                            title: "Data Suhu Badan",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message,
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
        }
    };

    const PostTreatmentSSPFunc = async () => {
        setLoading(true)

        try {
            setButtonLabel("Kirim treatment pasien SSP");

            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const code = props?.data_medical_record?.medical_treatment_invoices
                ?.flatMap(invoice => invoice?.medical_record?.treatment_plan_detail?.treatment_data) || [];

            if (!code) {
                swal({
                    title: 'Data treatment pasien tidak ada',
                    text: 'Pastikan kode icd-9 treatment telah diinput!',
                    icon: 'warning',
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;

            const doctorName = props?.doctor_name
            const doctorIHSNumber = props?.doctor_id_ssp;
            await PostTreatmentSSP(
                patientIdSSP,
                appointmentIdSSP,
                patientFirstname,
                patientLastname,
                code,
                createdAt,
                doctorIHSNumber,
                doctorName  
            );

            UpdateDataTreatmentSSPFunc()
            swal({
                title: "Success",
                text: "Suhu satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });


            setShowProcedureSSPButton(false)
            setShowBloodButton(true)
            setLoading(false)

        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code

            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data treatment pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataTreatmentSSPFunc()
                        setShowProcedureSSPButton(false)
                        setShowBloodButton(true)

                        swal({
                            title: "Data Treatment Pasien",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message,
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
        }
    };

    console.log(props?.doctor_name)
    console.log(props?.doctor_ihs)
    // StartPostAppointmentSSP
    const PostBloodTypeSSPFunc = async () => {
        setLoading(true)

        try {
            setButtonLabel("Kirim...1");
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;


            const bloodType = getPhysicalCheckPatientData?.blood_type;

            const bloodTypeMap = {
                "Group A": { code: "LA19710-5", display: "Group A" },
                "Group B": { code: "LA19709-7", display: "Group B" },
                "Group AB": { code: "LA28449-9", display: "Group AB" },
                "Group O": { code: "LA19708-9", display: "Group O" }
            };

            const bloodTypeArray = bloodType
                ? [
                    {
                        code: bloodTypeMap[bloodType]?.code || "",
                        display: bloodTypeMap[bloodType]?.display || bloodType
                    }
                ]
                : [];
            const doctorName = props?.doctor_name
            const doctorIdSSP = props?.doctor_id_ssp;
            await PostBloodTypeSSP(
                patientIdSSP,
                appointmentIdSSP,
                patientFirstname,
                patientLastname,
                bloodTypeArray,
                createdAt,
                doctorName,
                doctorIdSSP,
            );

            UpdateDataBloodTypeSSPFunc()

            swal({
                title: "Success",
                text: "Golongan darah satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });

            setShowBloodButton(false)
            setShowRhesusButton(true)
            setLoading(false)

        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code

            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });

                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data golongan darah pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataBloodTypeSSPFunc()
                        setShowBloodButton(false)
                        setShowRhesusButton(true)
                        swal({
                            title: "Data Golongan Darah Pasien",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });

            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message || "Terjadi kesalahan",
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
        }
    };
    // EndPostAppointmentSSP

    const PostDebrisIndexSSPFunc = async () => {
        setLoading(true)
        try {
            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const formattedBodySite = debrisIndexData
                .flatMap(item => ({
                    code: item.code_position,
                    display: item.position
                }));

            const formattedValueableConcept = debrisIndexData
                .flatMap(item =>
                    (item.debris_index_data ?? []).map(debris => ({
                        code: debris.code_display_name ?? null,
                        display: debris.display_name ?? null,
                    }))
                );
            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;
            const doctorName = props?.doctor_name
            const doctorIdSSP = props?.doctor_id_ssp;

            await PostDebrisIndexSSP(
                patientIdSSP,
                appointmentIdSSP,
                patientFirstname,
                patientLastname,
                formattedValueableConcept,
                formattedBodySite,
                createdAt,
                doctorName,
                doctorIdSSP
            );

            UpdateDataDebrisIndexSSPFunc()

            swal({
                title: "Success",
                text: "Debris index satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });

            setShowDebrisIndexButton(false)
            setShowKalkulusIndexButton(true)
            setLoading(false)
        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code
            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });

                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data debris index pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataDebrisIndexSSPFunc()
                        setShowDebrisIndexButton(false)
                        setShowKalkulusIndexButton(true)

                        swal({
                            title: "Data Debris Index Pasien",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message || "Terjadi kesalahan",
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
        }
    };


    const PostCalculusIndexSSPFunc = async () => {
        setLoading(true)

        try {
            setButtonLabel("Kirim...3");
            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const formattedBodySite = kalkulusIndexData
                .flatMap(item => ({
                    code: item.code_position,
                    display: item.position
                }));

            const formattedValueableConcept = kalkulusIndexData
                .flatMap(item =>
                    (item.calculus_index_data ?? []).map(calculus => ({
                        code: calculus.code_display_name ?? null,
                        display: calculus.display_name ?? null,
                    }))
                );

            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;

            const doctorName = props?.doctor_name
            const doctorIdSSP = props?.doctor_id_ssp;

            await PostKalkulusIndexSSP(
                patientIdSSP,
                appointmentIdSSP,
                patientFirstname,
                patientLastname,
                formattedValueableConcept,
                formattedBodySite,
                createdAt,
                doctorName,
                doctorIdSSP,
            );

            UpdateDataKalkulusIndexSSPFunc()

            swal({
                title: "Success",
                text: "Kalkulus index satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });
            setShowKalkulusIndexButton(false)
            setShowScoreKalkulusIndexButton(true)
            setLoading(false)
        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code

            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });

                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data kalkulus index pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataKalkulusIndexSSPFunc()
                        setShowKalkulusIndexButton(false)
                        setShowScoreKalkulusIndexButton(true)

                        swal({
                            title: "Data Kalkulus Index Pasien",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message || "Terjadi kesalahan",
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
        }
    };

    const PostScoreCalculusIndexSSPFunc = async () => {
        setLoading(true)
        try {

            // Rumus Skor Kalkulus Index
            // Total skor kalkulus
            const totalScore = (kalkulusIndexData ?? [])
                .flatMap(item => item.calculus_index_data ?? [])
                .reduce((sum, curr) => sum + Number(curr.score || 0), 0);
            // Hitung jumlah gigi yang punya data kalkulus
            const totalTeeth = (kalkulusIndexData ?? []).length;
            // Hitung CI-S (Kalkulus Index Simplified)
            const calculusIndex = totalTeeth > 0 ? (totalScore / totalTeeth) : 0;

            setButtonLabel("Kirim...4");
            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const score = calculusIndex


            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;


            const doctorName = props?.doctor_name
            const doctorIdSSP = props?.doctor_id_ssp;

            await PostScoreKalkulusIndexSSP(
                patientIdSSP,
                appointmentIdSSP,
                patientFirstname,
                patientLastname,
                score,
                createdAt,
                doctorName,
                doctorIdSSP
            );

            UpdateDataSkorKalkulusIndexSSPFunc()

            swal({
                title: "Success",
                text: "Skor Kalkulus index satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });

            setShowScoreKalkulusIndexButton(false)
            setShowScoreDebrisIndexButton(true)
            setLoading(false)

        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code

            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });

                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data skor kalkulus index pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataSkorKalkulusIndexSSPFunc()
                        setShowScoreKalkulusIndexButton(false)
                        setShowScoreDebrisIndexButton(true)


                        swal({
                            title: "Data Skor Kalkulus Index Pasien",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message || "Terjadi kesalahan",
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
        }
    };

    const PostScoreDebrisIndexSSPFunc = async () => {
        setLoading(true)

        try {

            // Rumus Skor Kalkulus Index
            // Total skor kalkulus
            const totalScore = (debrisIndexData ?? [])
                .flatMap(item => item.debris_index_data ?? [])
                .reduce((sum, curr) => sum + Number(curr.score || 0), 0);
            // Hitung jumlah gigi yang punya data kalkulus
            const totalTeeth = (debrisIndexData ?? []).length;
            // Hitung CI-S (Kalkulus Index Simplified)
            const debrisIndex = totalTeeth > 0 ? (totalScore / totalTeeth) : 0;

            setButtonLabel("Kirim...5");
            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const score = debrisIndex


            const createdAt = `${getPhysicalCheckPatientData?.created_at?.split(" ")[0]}T${getPhysicalCheckPatientData?.created_at?.split(" ")[1]}+00:00`;

            const doctorName = props?.doctor_name
            const doctorIdSSP = props?.doctor_id_ssp;

            await PostScoreDebrisIndexSSP(
                patientIdSSP,
                appointmentIdSSP,
                patientFirstname,
                patientLastname,
                score,
                createdAt,
                doctorName,
                doctorIdSSP
            );

            UpdateDataSkorDebrisIndexSSPFunc()

            swal({
                title: "Success",
                text: "Skor debris index satu sehat berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });

            setShowScoreDebrisIndexButton(false)
            setLoading(false)

        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.issue?.[0]?.code

            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data skor debris index pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        UpdateDataSkorDebrisIndexSSPFunc()
                        setShowScoreDebrisIndexButton(false)

                        swal({
                            title: "Data Skor Debris Index Pasien",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message || "Terjadi kesalahan",
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
            }
        }
    };

    const PostPatientSSPFunc = async () => {
        setLoading(true)
        try {
            if (!isPatientDataValid) {
                swal({
                    title: "Tidak Bisa Melanjutkan",
                    text: "Data pasien dari SatuSehat tidak valid. Mohon periksa kembali NIK pasien.",
                    icon: "warning",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
                return;
            }

            if (!isLocationDataValid) {
                swal({
                    title: "Tidak Bisa Melanjutkan",
                    text: "Data pasien dari SatuSehat tidak valid. Mohon periksa kembali data Ruangan pasien.",
                    icon: "warning",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
                return;
            }

            setButtonLabel("Lanjutkan...");

            if (
                patientData?.province === null ||
                patientData.province.trim() === "" ||
                patientData?.regency === null ||
                patientData.regency.trim() === "" ||
                patientData?.district === null ||
                patientData.district.trim() === "" ||
                patientData?.sub_district === null ||
                patientData.sub_district.trim() === ""
            ) {
                swal({
                    title: 'Failed',
                    text: `Data domisili pasien diperlukan untuk melanjutkan proses ini.`,
                    icon: 'warning',
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
                return;
            }

            const nic_number = patientData?.nic_number;
            const first_name = patientData?.first_name;
            const last_name = patientData?.last_name;
            const phone_number = patientData?.phone_number;
            const gender = patientData?.gender;
            const date_birth = patientData?.date_birth;
            const residence_address = patientData?.residence_address;
            const province = patientData?.province;
            const regency = patientData?.regency;
            const district = patientData?.district;
            const sub_district = patientData?.sub_district;

            await PostPatientSSP(
                nic_number,
                first_name,
                last_name,
                phone_number,
                gender,
                date_birth,
                residence_address,
                province,
                regency,
                district,
                sub_district
            );

            swal({
                title: "Success",
                text: "Patient SSP berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });

            setShowEncounterSSPButton(true)
            setShowAppointmentSSPButton(true)
            setLoading(false)
        } catch (error) {
            console.log(error)
            const message = error.response?.data?.error?.active;

            const code = error?.response?.data?.error?.issue?.[0]?.code;

            if (code === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Melanjutkan pengiriman data pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, Kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        swalWithBootstrapButtons.fire({
                            title: "Terkirim!",
                            text: "Data berhasil terkirim ke satu sehat.",
                            icon: "success"
                        });
                        setPatientSSPDuplicate(message)
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });

            } else {
                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim!",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        swalWithBootstrapButtons.fire({
                            title: "Terkirim!",
                            text: "Data berhasil terkirim ke satu sehat.",
                            icon: "success"
                        });
                        setPatientSSPDuplicate(message)
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            }
        }
    };


    const PostEncounterPatientSSPFunc = async () => {
        try {
            // setButtonLabel("Kirim encounter pasien");
            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;
            const appointment = props?.id_appointment;
            const dateAppointment = props?.date_appointment;
            const timeAppointment = props?.time_appointment;
            const patientFirstname = patientData?.first_name;
            const patientLastname = patientData?.last_name;
            const roomId = getLocationSSPData.entry[0].resource.id;
            const roomName = getLocationSSPData.entry[0].resource.description;
            const doctorName = props?.doctor_name
            const doctorIHSNumber = props?.doctor_id_ssp;

            await PostEncounterSSP(
                patientIdSSP,
                appointment,
                dateAppointment,
                timeAppointment,
                patientFirstname,
                patientLastname,
                roomId,
                roomName,
                doctorIHSNumber,
                doctorName,
            );

            swal({
                title: "Success",
                text: "Encounter berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });

            setButtonLabel("Terkirim");
            //setButtonColour("#28a745");
            setLoading(false)

        } catch (error) {
            const message = error?.response?.data?.error?.issue?.[0]?.code;
            if (message === "duplicate") {
                setIsDuplicate(true);

                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });
                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Kirim data encounter pasien satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, kirim! ",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        swal({
                            title: "Data Encounter",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });
                        setShowEncounterSSPButton(true)
                        setShowAppointmentSSPButton(true)
                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setPatientSSPDuplicate(message)
                        setLoading(false)
                    }
                });
            } else {
                console.log('yes1')
                swal({
                    title: "Gagal",
                    text: error.response.data.message || "Terjadi kesalahan",
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                setLoading(false)
                console.error("Error PostAppointmentSSPFunc:", error);
            }
        }
    };

    // StartPostAppointmentSSP
    const PostAppointmentSSPFunc = async () => {
        setLoading(true)
        try {
            setButtonLabel("Kirim Sistole");
            const appointmentId = props?.id_appointment;
            const appointmentIdSSP = getPatientIndexEncounterSatuSehat?.resource?.id;
            const patientId = props?.id_patient;
            const patientIdSSP = getDataPatientByNikSatuSehat?.resource?.id;


            await PostAppointmentSSP(
                appointmentId,
                appointmentIdSSP,
                patientId,
                patientIdSSP
            );


            swal({
                title: "Success",
                text: "Appointment SSP berhasil dikirim!",
                icon: "success",
                timer: 3000,
                buttons: false,
            });

            setButtonLabel("Terkirim");
            //setButtonColour("#28a745");
            setLoading(false)
        } catch (error) {
            console.log(error)
            const message = error.response?.data?.message;
            if (message === "duplicate") {
                setIsDuplicate(true);


                const swalWithBootstrapButtons = Swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success ms-2",
                        cancelButton: "btn btn-danger"
                    },
                    buttonsStyling: false
                });

                swalWithBootstrapButtons.fire({
                    title: "Apakah kamu yakin?",
                    text: "Lanjutkan untuk mengirim data satu sehat.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Ya, Lanjutkan...",
                    cancelButtonText: "Tidak, batal!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        setShowAppointmentSSPButton(false)
                        setShowEncounterSSPButton(false)
                        setShowSistoleSSPButton(true)

                        swal({
                            title: "Data Appointment",
                            text: "Berhasil terkirim...",
                            icon: "success",
                            timer: 3000,
                            buttons: false,
                        });

                        setLoading(false)
                    } else if (
                        result.dismiss === Swal.DismissReason.cancel
                    ) {
                        swalWithBootstrapButtons.fire({
                            title: "Batal!",
                            text: "Data gagal terkirim ke satu sehat.",
                            icon: "error"
                        });
                        setLoading(false)
                    }
                });
            } else {
                swal({
                    title: "Gagal",
                    text: error.response.data.message || "Terjadi kesalahan",
                    icon: "error",
                    timer: 3000,
                    buttons: false,
                });
                console.error("Error PostAppointmentSSPFunc:", error);
            }
        }
    };
    // EndPostAppointmentSSPappoin
    return (
        <>
            {loading && <LoaderHome />}

            {!isDuplicate ? (
                <>
                    <Button
                        className="mt-2 w-100 mx-1"
                        block
                        style={{
                            padding: "8px 15px",
                            fontSize: "12px",
                            borderRadius: "5px",
                            backgroundColor:
                                appointmentData?.blood_type === 1 &&
                                    appointmentData?.status_sistole_ssp === 1 &&
                                    appointmentData?.status_distole_ssp === 1 &&
                                    appointmentData?.status_observation_ssp === 1 &&
                                    appointmentData?.status_procedure_ssp === 1 &&
                                    appointmentData?.rhesus === 1 &&
                                    appointmentData?.pregnancy_status === 1 &&
                                    appointmentData?.debris_indices === 1 &&
                                    appointmentData?.calculus_indices === 1 &&
                                    appointmentData?.score_calculus_indices === 1 &&
                                    appointmentData?.score_debris_indices === 1 ? '#28a745'
                                    : buttonColour,
                            color: "white",
                            border: "none",
                            boxShadow:
                                buttonColour === "#28a745"
                                    ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                    : "none",
                        }}
                        onClick={() => {
                            if (patientSSPDuplicate) {
                                PostEncounterPatientSSPFunc();
                            } else {
                                PostPatientSSPFunc();
                            }
                        }}
                        disabled={appointmentData?.blood_type === 1 &&
                            appointmentData?.status_sistole_ssp === 1 &&
                            appointmentData?.status_distole_ssp === 1 &&
                            appointmentData?.status_observation_ssp === 1 &&
                            appointmentData?.status_procedure_ssp === 1 &&
                            appointmentData?.rhesus === 1 &&
                            appointmentData?.pregnancy_status === 1 &&
                            appointmentData?.debris_indices === 1 &&
                            appointmentData?.calculus_indices === 1 &&
                            appointmentData?.score_calculus_indices === 1 &&
                            appointmentData?.score_debris_indices === 1}
                    >
                        {patientSSPDuplicate ? (
                            <>
                                Kirim Encounter
                            </>
                        ) : (
                            <>
                                {
                                    appointmentData?.status_sistole_ssp === 1 &&
                                        appointmentData?.status_distole_ssp === 1 &&
                                        appointmentData?.status_observation_ssp === 1 &&
                                        appointmentData?.status_procedure_ssp === 1 &&
                                        appointmentData?.rhesus === 1 &&
                                        appointmentData?.pregnancy_status === 1 &&
                                        appointmentData?.debris_indices === 1 &&
                                        appointmentData?.calculus_indices === 1 &&
                                        appointmentData?.score_calculus_indices === 1 &&
                                        appointmentData?.score_debris_indices === 1 ?
                                        <>
                                            Terkirim
                                        </>
                                        :
                                        <>

                                            Kirim Satu Sehat
                                        </>
                                }
                            </>
                        )}
                    </Button>
                </>
            ) : (
                <>
                    {showEncounterSSPButton && (
                        <Button
                            className="mt-2 w-100 mx-1"
                            block
                            style={{
                                padding: "8px 15px",
                                fontSize: "12px",
                                borderRadius: "5px",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                boxShadow:
                                    buttonColour === "#28a745"
                                        ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                        : "none",
                            }}
                            disabled
                        // onClick={PostEncounterPatientSSPFunc}
                        >
                            Encounter Terkirim
                        </Button>
                    )}
                </>
            )}

            {/* Tombol Appointment SSP */}
            {showAppointmentSSPButton ? (
                <Button
                    className="mt-2 w-100 mx-1"
                    block
                    style={{
                        padding: "8px 15px",
                        fontSize: "12px",
                        borderRadius: "5px",
                        backgroundColor: buttonColour,
                        color: "white",
                        border: "none",
                        boxShadow:
                            buttonColour === "#28a745"
                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                : "none",
                    }}
                    onClick={PostAppointmentSSPFunc}
                >
                    Lanjutkan
                </Button>
            ) : (

                <>
                    {/* Tombol Sistole SSP */}
                    {showSistoleSSPButton && (
                        <Button
                            className="mt-2 w-100 mx-1"
                            block
                            style={{
                                padding: "8px 15px",
                                fontSize: "12px",
                                borderRadius: "5px",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                boxShadow:
                                    buttonColour === "#28a745"
                                        ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                        : "none",
                            }}
                            disabled
                        >
                            Appointment terikirim
                        </Button>
                    )}
                </>
            )}

            {/* Tombol Sistole SSP */}
            {showSistoleSSPButton ? (
                <Button
                    className="mt-2 w-100 mx-1"
                    block
                    style={{
                        padding: "8px 15px",
                        fontSize: "12px",
                        borderRadius: "5px",
                        backgroundColor: buttonColour,
                        color: "white",
                        border: "none",
                        boxShadow:
                            buttonColour === "#28a745"
                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                : "none",
                    }}
                    onClick={PostSistoleSSPFunc}
                >
                    {buttonLabel}
                </Button>
            ) : (
                <>
                    {/* Tombol Sistole SSP */}
                    {showDistoleSSPButton && (
                        <Button
                            className="mt-2 w-100 mx-1"
                            block
                            style={{
                                padding: "8px 15px",
                                fontSize: "12px",
                                borderRadius: "5px",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                boxShadow:
                                    buttonColour === "#28a745"
                                        ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                        : "none",
                            }}
                            disabled
                        >
                            Sistole terikirim
                        </Button>
                    )}
                </>
            )}

            {/* Tombol Golongan Darah */}
            {showDistoleSSPButton ? (
                <Button
                    className="mt-2 w-100 mx-1"
                    block
                    style={{
                        padding: "8px 15px",
                        fontSize: "12px",
                        borderRadius: "5px",
                        backgroundColor: buttonColour,
                        color: "white",
                        border: "none",
                        boxShadow:
                            buttonColour === "#28a745"
                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                : "none",
                    }}
                    onClick={PostDistoleSSPFunc}
                >
                    Kirim Distole SSP
                </Button>
            ) : (
                <>
                    {showSuhuSSPButton && (
                        <>
                            <Button
                                className="mt-2 w-100 mx-1"
                                block
                                style={{
                                    padding: "8px 15px",
                                    fontSize: "12px",
                                    borderRadius: "5px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                    border: "none",
                                    boxShadow:
                                        buttonColour === "#28a745"
                                            ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                            : "none",
                                }}
                                disabled
                            >
                                Distole terikirim
                            </Button>
                        </>
                    )}

                </>
            )}

            {showSuhuSSPButton ? (
                <>
                    <Button
                        className="mt-2 w-100 mx-1"
                        block
                        style={{
                            padding: "8px 15px",
                            fontSize: "12px",
                            borderRadius: "5px",
                            backgroundColor: buttonColour,
                            color: "white",
                            border: "none",
                            boxShadow:
                                buttonColour === "#28a745"
                                    ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                    : "none",
                        }}
                        onClick={PostSuhuSSPFunc}
                    >
                        Kirim Suhu SSP
                    </Button>
                </>
            ) : (
                <>
                    {showProcedureSSPButton && (
                        <>
                            <Button
                                className="mt-2 w-100 mx-1"
                                block
                                style={{
                                    padding: "8px 15px",
                                    fontSize: "12px",
                                    borderRadius: "5px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                    border: "none",
                                    boxShadow:
                                        buttonColour === "#28a745"
                                            ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                            : "none",
                                }}
                                disabled
                            // onClick={PostDistoleSSPFunc}
                            >
                                Suhu terikirim
                            </Button>
                        </>
                    )}
                </>
            )}

            {showProcedureSSPButton ? (
                <>
                    <Button
                        className="mt-2 w-100 mx-1"
                        block
                        style={{
                            padding: "8px 15px",
                            fontSize: "12px",
                            borderRadius: "5px",
                            backgroundColor: buttonColour,
                            color: "white",
                            border: "none",
                            boxShadow:
                                buttonColour === "#28a745"
                                    ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                    : "none",
                        }}
                        onClick={PostTreatmentSSPFunc}
                    >
                        Kirim Treatment SSP
                    </Button>
                </>
            ) : (
                <>
                    {showBloodButton && (
                        <Button
                            className="mt-2 w-100 mx-1"
                            block
                            style={{
                                padding: "8px 15px",
                                fontSize: "12px",
                                borderRadius: "5px",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                boxShadow:
                                    buttonColour === "#28a745"
                                        ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                        : "none",
                            }}
                            disabled
                        // onClick={PostDistoleSSPFunc}
                        >
                            Treatment terikirim
                        </Button>
                    )}
                </>
            )}

            {/* Tombol Golongan Darah */}
            {showBloodButton ? (
                <Button
                    className="mt-2 w-100 mx-1"
                    block
                    style={{
                        padding: "8px 15px",
                        fontSize: "12px",
                        borderRadius: "5px",
                        backgroundColor: buttonColour,
                        color: "white",
                        border: "none",
                        boxShadow:
                            buttonColour === "#28a745"
                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                : "none",
                    }}
                    onClick={PostBloodTypeSSPFunc}
                >
                    Kirim Golongan Darah SSP
                </Button>
            ) : (
                <>
                    {showRhesusButton && (
                        <>
                            <Button
                                className="mt-2 w-100 mx-1"
                                block
                                style={{
                                    padding: "8px 15px",
                                    fontSize: "12px",
                                    borderRadius: "5px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                    border: "none",
                                    boxShadow:
                                        buttonColour === "#28a745"
                                            ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                            : "none",
                                }}
                                disabled
                            // onClick={PostDistoleSSPFunc}
                            >
                                Golongan darah terkirim
                            </Button>
                        </>
                    )}
                </>
            )}

            {/* Tombol Rhesus */}
            {showRhesusButton ? (
                <Button
                    className="mt-2 w-100 mx-1"
                    block
                    style={{
                        padding: "8px 15px",
                        fontSize: "12px",
                        borderRadius: "5px",
                        backgroundColor: buttonColour,
                        color: "white",
                        border: "none",
                        boxShadow:
                            buttonColour === "#28a745"
                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                : "none",
                    }}
                    onClick={PostRhesusSSPFunc}
                >
                    Kirim Rhesus SSP
                </Button>
            ) : (
                <>
                    {showPregnancyStatusButton && (
                        <Button
                            className="mt-2 w-100 mx-1"
                            block
                            style={{
                                padding: "8px 15px",
                                fontSize: "12px",
                                borderRadius: "5px",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                boxShadow:
                                    buttonColour === "#28a745"
                                        ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                        : "none",
                            }}
                            disabled
                        // onClick={PostDistoleSSPFunc}
                        >
                            Rhesus terkirim
                        </Button>
                    )}
                </>
            )}

            {/* Tombol Status Kehamilan */}
            {showPregnancyStatusButton ? (
                <Button
                    className="mt-2 w-100 mx-1"
                    block
                    style={{
                        padding: "8px 15px",
                        fontSize: "12px",
                        borderRadius: "5px",
                        backgroundColor: buttonColour,
                        color: "white",
                        border: "none",
                        boxShadow:
                            buttonColour === "#28a745"
                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                : "none",
                    }}
                    onClick={PostPregnancyStatusSSPFunc}
                >
                    Kirim Status Kehamilan SSP
                </Button>
            ) : (
                <>
                    {showDebrisIndexButton && (
                        <Button
                            className="mt-2 w-100 mx-1"
                            block
                            style={{
                                padding: "8px 15px",
                                fontSize: "12px",
                                borderRadius: "5px",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                boxShadow:
                                    buttonColour === "#28a745"
                                        ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                        : "none",
                            }}
                            disabled
                        // onClick={PostDistoleSSPFunc}
                        >
                            Status kehamilan terkirim
                        </Button>
                    )}
                </>
            )}

            {/* Tombol Debris */}
            {showDebrisIndexButton ? (
                <Button
                    className="mt-2 w-100 mx-1"
                    block
                    style={{
                        padding: "8px 15px",
                        fontSize: "12px",
                        borderRadius: "5px",
                        backgroundColor: buttonColour,
                        color: "white",
                        border: "none",
                        boxShadow:
                            buttonColour === "#28a745"
                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                : "none",
                    }}
                    onClick={PostDebrisIndexSSPFunc}
                >
                    Kirim Debris Index SSP
                </Button>
            ) : (
                <>
                    {showKalkulusIndexButton && (
                        <Button
                            className="mt-2 w-100 mx-1"
                            block
                            style={{
                                padding: "8px 15px",
                                fontSize: "12px",
                                borderRadius: "5px",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                boxShadow:
                                    buttonColour === "#28a745"
                                        ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                        : "none",
                            }}
                            disabled
                        // onClick={PostDistoleSSPFunc}
                        >
                            Debris index terkirim
                        </Button>
                    )}
                </>
            )}

            {/* Tombol Kalkulus */}
            {showKalkulusIndexButton ? (
                <Button
                    className="mt-2 w-100 mx-1"
                    block
                    style={{
                        padding: "8px 15px",
                        fontSize: "12px",
                        borderRadius: "5px",
                        backgroundColor: buttonColour,
                        color: "white",
                        border: "none",
                        boxShadow:
                            buttonColour === "#28a745"
                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                : "none",
                    }}
                    onClick={PostCalculusIndexSSPFunc}
                >
                    Kirim Kalkulus Index SSP
                </Button>
            ) : (
                <>
                    {showScoreKalkulusIndexButton && (
                        <Button
                            className="mt-2 w-100 mx-1"
                            block
                            style={{
                                padding: "8px 15px",
                                fontSize: "12px",
                                borderRadius: "5px",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                boxShadow:
                                    buttonColour === "#28a745"
                                        ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                        : "none",
                            }}
                            disabled
                        // onClick={PostDistoleSSPFunc}
                        >
                            Kalkulus index terkirim
                        </Button>
                    )}
                </>
            )}

            {/* Tombol Skor Kalkulus */}
            {showScoreKalkulusIndexButton ? (
                <Button
                    className="mt-2 w-100 mx-1"
                    block
                    style={{
                        padding: "8px 15px",
                        fontSize: "12px",
                        borderRadius: "5px",
                        backgroundColor: buttonColour,
                        color: "white",
                        border: "none",
                        boxShadow:
                            buttonColour === "#28a745"
                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                : "none",
                    }}
                    onClick={PostScoreCalculusIndexSSPFunc}
                >
                    Kirim  Skor Kalkulus Index SSP
                </Button>
            ) : (
                <>
                    {showScoreDebrisIndexButton && (
                        <Button
                            className="mt-2 w-100 mx-1"
                            block
                            style={{
                                padding: "8px 15px",
                                fontSize: "12px",
                                borderRadius: "5px",
                                backgroundColor: "#28a745",
                                color: "white",
                                border: "none",
                                boxShadow:
                                    buttonColour === "#28a745"
                                        ? "0 0 10px #28a745(73, 142, 246, 0.5)"
                                        : "none",
                            }}
                            disabled
                        // onClick={PostDistoleSSPFunc}
                        >
                            Skor kalkulus index terkirim
                        </Button>
                    )}
                </>
            )}

            {/* Tombol Skor Debris */}
            {showScoreDebrisIndexButton ? (
                <Button
                    className="mt-2 w-100 mx-1"
                    block
                    style={{
                        padding: "8px 15px",
                        fontSize: "12px",
                        borderRadius: "5px",
                        backgroundColor: buttonColour,
                        color: "white",
                        border: "none",
                        boxShadow:
                            buttonColour === "#28a745"
                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                : "none",
                    }}
                    onClick={PostScoreDebrisIndexSSPFunc}
                >
                    Kirim Skor Debris Index SSP
                </Button>
            ) : (
                <>
                    {
                        patientSSPDuplicate &&
                        !showScoreDebrisIndexButton &&
                        !showScoreKalkulusIndexButton &&
                        !showDebrisIndexButton &&
                        !showKalkulusIndexButton &&
                        !showPregnancyStatusButton &&
                        !showRhesusButton &&
                        !showBloodButton &&
                        !showProcedureSSPButton &&
                        !showSuhuSSPButton &&
                        !showDistoleSSPButton &&
                        !showSistoleSSPButton &&
                        !showAppointmentSSPButton &&
                        !showEncounterSSPButton
                        && (
                            <>
                                <Button
                                    className="mt-2 w-100 mx-1"
                                    block
                                    style={{
                                        padding: "8px 15px",
                                        fontSize: "12px",
                                        borderRadius: "5px",
                                        backgroundColor: "#28a745",
                                        color: "white",
                                        border: "none",
                                        boxShadow:
                                            buttonColour === "#28a745"
                                                ? "0 0 10px rgba(73, 142, 246, 0.5)"
                                                : "none",
                                    }}
                                    disabled
                                >
                                    Terkirim
                                </Button>
                            </>
                        )}
                </>
            )}
        </>
    )
}